<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_1"></a><span class="underline"><span class="small">PART ONE</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780857901729_06_pt1.vue?b4c3eac0